import {
  addSurgicalActEndpoint,
  deleteSurgicalActEndpoint,
  updateSurgicalActEndpoint,
} from "./api/SurgicalAct";

export const addSurgicalActToDatabase = async surgicalActData => {
  try {
    const response = await addSurgicalActEndpoint(surgicalActData);
    return response.data;
  } catch (error) {
    throw new Error(`Error adding surgical act: ${error.message}`);
  }
};

export const deleteSurgicalActFromDatabase = async surgicalActId => {
  try {
    const response = await deleteSurgicalActEndpoint(surgicalActId);
    return response.data;
  } catch (error) {
    throw new Error(`Error deleting surgical act: ${error.message}`);
  }
};

export const updateSurgicalActInDatabase = async (
  updatedSurgicalActData,
  surgicalActId
) => {
  try {
    const response = await updateSurgicalActEndpoint(
      updatedSurgicalActData,
      surgicalActId
    );
    return response;
  } catch (error) {
    throw new Error(`Error updating surgical act: ${error.message}`);
  }
};
